import React, { Component } from "react";
import SimpleModalWrapped from "../common/Modal";
import { Trans as Translate } from "react-i18next";
import Grid from "@mui/material/Grid";
import TextField from "../common/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import SearchDevices from "../Devices/searchItems";
import { withStyles } from "@mui/styles";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Tooltip from "./../common/Tooltip";
import moment from "moment";
import { Api, checkPrivileges, plateTypes } from "../../Helpers";
import Selector from "../common/Select";

import axios from "axios";
import Button from "../common/Button";
import SingleSelect from "../common/SingleSelect";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "../common/Checkbox";
import InfoIcon from "@mui/icons-material/Info";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
// import withTranslationWrapper from "../../HOC/withTranslation";
import CustomDatePicker from "../common/CustomDatePicker";
// import { connect } from "react-redux";

// const allTypes = ["Leasing"];

const poolTypes = [
  {
    key: "contractual",
    name: "Contractual",
  },
  {
    key: "exclusive",
    name: "Exclusive",
  },
  {
    key: "common",
    name: "Common",
  },
  {
    key: "otherVertical",
    name: "Other Vertical",
  },
  {
    key: "cooperateService",
    name: "Cooperate Service",
  },
];
const vehicleEntitlementList = [
  {
    key: 1,
    name: "Company Car",
  },
  {
    key: 2,
    name: "New Policy Company Car - Upgrade",
  },
  {
    key: 3,
    name: "New Policy Job Car",
  },
  {
    key: 4,
    name: "New Policy Job Car - Upgrade",
  },
  {
    key: 5,
    name: "Old Policy Job Car",
  },
  {
    key: 6,
    name: " Old Policy Upgrade - Paid",
  },
  {
    key: 7,
    name: "Old Policy Upgrade",
  },
  {
    key: 8,
    name: "Department Assets",
  },
];
const styles = (theme) => ({
  root: {
    background: "blue",
    marginBottom: "10px",
  },
  root2: {
    background: "grey",
    marginBottom: "10px",
  },
  whiteColor: {
    color: "white",
  },
});

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

/** UAE plate band colors by emirate (matched via city id / cityEn / label / cityAr). */
const EMIRATE_PLATE_STYLES = [
  {
    id: 1,
    keys: ["abu dhabi", "abudhabi", "أبوظبي", "ابوظبي"],
    band: "#c8102e",
    bandText: "#fff",
  },
  {
    id: 2,
    keys: ["dubai", "دبي"],
    band: "#0d47a1",
    bandText: "#fff",
  },
  {
    id: 3,
    keys: ["sharjah", "الشارقة", "الشارقه"],
    band: "#1b5e20",
    bandText: "#fff",
  },
  {
    id: 4,
    keys: ["ajman", "عجمان"],
    band: "#00695c",
    bandText: "#fff",
  },
  {
    id: 5,
    keys: ["umm al quwain", "umm al-quwain", "أم القيوين", "ام القيوين"],
    band: "#00838f",
    bandText: "#fff",
  },
  {
    id: 6,
    keys: ["ras al khaimah", "ras al-khaimah", "رأس الخيمة", "راس الخيمة"],
    band: "#6d1b2a",
    bandText: "#fff",
  },
  {
    id: 7,
    keys: ["fujairah", "الفجيرة", "الفجيره"],
    band: "#283593",
    bandText: "#fff",
  },
];

const DEFAULT_PLATE_STYLE = {
  id: 0,
  band: "#1b5e20",
  bandText: "#fff",
};

const normalizeEmirateKey = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[\u064B-\u065F\u0670]/g, "") // Arabic diacritics
    .replace(/أ|إ|آ/g, "ا")
    .replace(/ة/g, "ه")
    .replace(/[_\-–—]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const resolveEmiratePlateStyle = (city = {}) => {
  // Prefer name match — API city.id is NOT the same as emirate style id (1–7).
  const haystack = normalizeEmirateKey(
    [city.cityEn, city.label, city.name, city.cityAr, city.region]
      .filter(Boolean)
      .join(" "),
  );

  const match =
    EMIRATE_PLATE_STYLES.find((e) =>
      e.keys.some((k) => {
        const key = normalizeEmirateKey(k);
        return haystack.includes(key) || haystack.replace(/\s/g, "").includes(key.replace(/\s/g, ""));
      }),
    ) || DEFAULT_PLATE_STYLE;

  return {
    cityAr: city.cityAr || "—",
    cityEn: city.cityEn || city.label || city.name || "UAE",
    categoryBg: match.band,
    categoryColor: match.bandText,
  };
};

/** Cities API may return "s*"/"s+" instead of "\s*"/"\s+". */
const normalizeCityPlateRegex = (regexStr) => {
  if (!regexStr) return "";
  return String(regexStr).replace(/(^|[^\\])s([*+])/g, (_, before, quant) => {
    return before + "\\s" + quant;
  });
};

/** Pull example plate from city.msg, e.g. "Example: 3 7777". */
const exampleFromCityMsg = (msg = "") => {
  const m = String(msg).match(
    /example\s*:\s*([A-Za-z0-9]+(?:\s+[A-Za-z0-9]+)?)/i,
  );
  return m ? m[1].trim().toUpperCase() : "";
};

/**
 * Split plate using selected city's regex (primary), then fallback split.
 * Formats: "A 12345", "3 7777", "AA 1234".
 */
const parseUaePlateParts = (plateValue = "", city = {}) => {
  const plate = String(plateValue || "").trim().toUpperCase();
  const example = exampleFromCityMsg(city.msg);
  const fallbackParts = (value) => {
    const parts = String(value || "")
      .trim()
      .toUpperCase()
      .split(/\s+/)
      .filter(Boolean);
    let plateLetters = "";
    let plateNumbers = "";
    if (parts.length >= 2) {
      plateNumbers = parts[parts.length - 1].replace(/[^\d٠-٩]/g, "");
      plateLetters = parts.slice(0, -1).join(" ");
    } else if (parts.length === 1) {
      if (/^[\d٠-٩]+$/.test(parts[0])) {
        plateNumbers = parts[0];
      } else {
        const match = parts[0].match(/^([A-Z]{1,2}|[0-9]{1,2})([\d٠-٩]+)$/);
        if (match) {
          plateLetters = match[1];
          plateNumbers = match[2];
        } else {
          plateLetters = parts[0];
        }
      }
    }
    return { plateLetters, plateNumbers };
  };

  let valid = false;
  let plateLetters = "";
  let plateNumbers = "";

  if (plate && city.regex) {
    try {
      const pattern = normalizeCityPlateRegex(city.regex);
      const re = new RegExp(pattern, "i");
      const m = plate.match(re);
      if (m) {
        valid = true;
        const groups = m.slice(1).filter((g) => g != null && String(g).length);
        if (groups.length >= 2) {
          plateLetters = String(groups[0]).toUpperCase();
          plateNumbers = String(groups[groups.length - 1]).replace(
            /[^\d٠-٩]/g,
            "",
          );
        } else {
          const fb = fallbackParts(plate);
          plateLetters = fb.plateLetters;
          plateNumbers = fb.plateNumbers;
        }
      } else {
        const fb = fallbackParts(plate);
        plateLetters = fb.plateLetters;
        plateNumbers = fb.plateNumbers;
      }
    } catch (e) {
      const fb = fallbackParts(plate);
      plateLetters = fb.plateLetters;
      plateNumbers = fb.plateNumbers;
    }
  } else if (plate) {
    const fb = fallbackParts(plate);
    plateLetters = fb.plateLetters;
    plateNumbers = fb.plateNumbers;
  } else if (example) {
    // Empty input → show city regex example on the plate
    const fb = fallbackParts(example);
    plateLetters = fb.plateLetters;
    plateNumbers = fb.plateNumbers;
  }

  return { plateLetters, plateNumbers, valid, example };
};

class addVehicle extends Component {
  constructor() {
    super();
    this.state = {
      attm_isVisable: false,
      inquiryResponse: "",
      errorResponse: "",
      typeName: ["Maintenance"],
      open: false,
    };
    this.addAttributes = this.addAttributes.bind(this);
  }
  componentWillMount() {
    if (this.props.editOption) {
      this.setState({
        typeName: this.props.form?.attributes?.typeName || ["Maintenance"],
      });
    }
  }

  addAttributes() {
    this.setState({
      attm_isVisable: !this.state.attm_isVisable,
    });
  }

  uploadFile = (e) => {
    console.log("image =", e.target.files[0]);
  };

  handleChange = (a, b) => {
    this.setState({ open: false });
    this.props.handleChangeForAttributesValues(a, { target: b });
  };

  verify = () => {
    this.setState({ errorResponse: "", inquiryResponse: "" });
    if (this.props.form.attributes.sequenceNumber) {
      axios
        .post(`${process.env.REACT_APP_WASL}/handleSocketRequest`, {
          hook: "getVehicle",
          account_id: this.props.serversettings.id,
          data: JSON.stringify({
            sequenceNumber: this.props.form.attributes.sequenceNumber,
            activity: "DEFAULT",
          }),
        })
        .then((response) => {
          if (
            response.status === 200 &&
            response.data &&
            response.data.referenceKey
          ) {
            this.props.handleChangeForAttributesValues("WASLKey", {
              target: { value: response.data.referenceKey },
            });
            this.props.formSubmit();
            this.props.dispatch(notifySuccess("Integrated With Wasl"));
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data && error.response.data.message) {
              const { message, data } = error.response.data;
              this.setState({
                inquiryResponse:
                  data?.resultCode ||
                  (message.toLowerCase() === "bad request"
                    ? "Not Registered"
                    : message),
              });
            } else {
              const {
                data: { resultCode, resultMsg, errorMsg, errorCode },
              } = error.response.data;
              this.setState({
                inquiryResponse:
                  resultMsg || resultCode || errorMsg || errorCode,
              });
            }
          }
        });
    } else {
      this.props.dispatch(notifyError("Please enter sequence number first"));
    }
  };

  submitWasl = () => {
    this.setState({ errorResponse: "", inquiryResponse: "" });
    const { waslCompanyRefKey } = this.props?.serversettings?.attributes || {};
    if (waslCompanyRefKey) {
      const {
        number,
        leftLetter,
        rightLetter,
        plateType,
        middleLetter,
        sequenceNumber,
      } = this.props.form.attributes;
      const { uniqueId } = this.props.vehicleTracker;
      if (
        number &&
        leftLetter &&
        rightLetter &&
        plateType &&
        middleLetter &&
        sequenceNumber &&
        uniqueId
      ) {
        axios
          .post(`${process.env.REACT_APP_WASL}/handleSocketRequest`, {
            hook: "registerVehicle",
            account_id: this.props.serversettings.id,
            data: JSON.stringify({
              uniqueId,
              sequenceNumber,
              activity: "DEFAULT",
              attributes: {
                rightLetter,
                number,
                leftLetter,
                middleLetter,
                plateType,
              },
            }),
            hook_prefix: waslCompanyRefKey,
          })
          .then((response) => {
            axios
              .get(`${Api}/refreshCache`)
              .then((response) => {})
              .catch((error) => {});
            if (
              response.status === 200 &&
              response.data &&
              response.data.success
            ) {
              if (
                response.data &&
                response.data.result &&
                response.data.success &&
                response.data.result.referenceKey
              ) {
                this.props.handleChangeForAttributesValues("WASLKey", {
                  target: { value: response.data.result.referenceKey },
                });
                this.props.formSubmit();
              }
            }
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              const {
                data: { resultCode, resultMsg, errorMsg, errorCode },
              } = error.response.data;
              this.setState({
                errorResponse: resultMsg || resultCode || errorMsg || errorCode,
              });
              // this.props.handleChangeForAttributesValues('WASLKey', { target: {value:error.response.data&&error.response.data.data&&error.response.data.data.result.referenceKey} } );
              // this.props.formSubmit();
            }
          });
      } else {
        this.setState({ errorResponse: "integration form incomplete" });
      }
    } else {
      this.props.dispatch(notifyError("Please Register your company first"));
    }
  };

  changeIMEI = () => {
    this.setState({ errorResponse: "", inquiryResponse: "" });
    const { waslCompanyRefKey } = this.props?.serversettings?.attributes || {};
    const { WASLKey, sequenceNumber } = this.props.form.attributes;
    const { uniqueId } = this.props.vehicleTracker;
    if (waslCompanyRefKey && WASLKey) {
      axios
        .post(`${process.env.REACT_APP_WASL}/handleSocketRequest`, {
          hook: "updateVehicle",
          account_id: this.props.serversettings.id,
          data: JSON.stringify({
            sequenceNumber,
            imeiNumber: uniqueId,
            activity: "DEFAULT",
          }),
        })
        .then((response) => {
          if (response && response.data && response.data.resultCode);
          this.setState({ inquiryResponse: response.data.resultCode }, () =>
            this.props.formSubmit(),
          );
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            const {
              data: { resultCode, resultMsg, errorMsg, errorCode },
            } = error.response.data;
            this.setState({
              errorResponse: resultMsg || resultCode || errorMsg || errorCode,
            });
          }
          let errMsg =
            (error.response &&
              error.response.data &&
              error.response.data.data &&
              error.response.data.data.resultCode) ||
            "somethingWentWrong";
          this.props.dispatch(notifyError(errMsg));
        });
    }
  };

  unlinkWasl = () => {
    this.setState({ errorResponse: "", inquiryResponse: "" });
    const { waslCompanyRefKey } = this.props?.serversettings?.attributes || {};
    const { WASLKey } = this.props.form.attributes;

    if (waslCompanyRefKey && WASLKey) {
      axios
        .post(`${process.env.REACT_APP_WASL}/handleSocketRequest`, {
          hook: "deleteVehicle",
          account_id: this.props.serversettings.id,
          hook_prefix: waslCompanyRefKey,
          hook_postfix: WASLKey,
          data: {
            activity: "DEFAULT",
          },
        })
        .then((response) => {
          this.props.handleChangeForAttributesValues(
            "WASLKey",
            { target: { value: "" } },
            false,
          );
          this.props.formSubmit();
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.data) {
            const {
              data: { resultCode, resultMsg, errorMsg, errorCode },
            } = error.response.data;
            this.setState({
              errorResponse: resultMsg || resultCode || errorMsg || errorCode,
            });
          }
          let errMsg =
            (error.response &&
              error.response.data &&
              error.response.data.data &&
              error.response.data.data.resultCode) ||
            "somethingWentWrong";
          this.props.dispatch(notifyError(errMsg));
        });
    } else {
      this.props.dispatch(notifyError("Please Register your company first"));
    }
  };

  UNSAFE_componentWillReceiveProps(n) {
    if (n.form.id !== this.props.form.id) {
      this.setState({
        inquiryResponse: "",
        errorResponse: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ typeName: event, open: true }, () => {
      this.props.handleChange("typeName", this.state.typeName);
    });
  };

  render() {
    const { classes } = this.props;
    const { form, cities } = this.props;
    let userType = this.props?.logInUsers?.userType;
    // const { attributes } = form;
    const WASLKey = form?.attributes?.WASLKey || "";
    const updatedUsers = (this.props.users || []).filter(
      (item) => item.userType === 3,
    );
    const { waslEnabled, waslCompanyRefKey } =
      this.props?.serversettings?.attributes || {};
    return (
      <div style={{ height: "100%", paddingRight: 4 }}>
        <SimpleModalWrapped
          visable={true}
          notShowAttributesBtn
          isButtonVisable={true}
          title="sharedVehicle"
          formSubmit={this.props.formSubmit}
          modalControle={this.props.onClose}
          buttonText={this.props.buttonText}
          btnCloseText="sharedBack"
          isVisableBtn={this.props.isVisableUserBtn}
          selectedItemId={this.props.selectedVehicle.id}
          waslFooter={
            waslEnabled ? (
              WASLKey ? (
                <>
                  <Button onClick={this.changeIMEI}>Change IMEI</Button>
                  <Button style={{ marginLeft: 10 }} onClick={this.unlinkWasl}>
                    Un-Link WASL
                  </Button>
                </>
              ) : (
                <Button onClick={this.submitWasl}>Link WASL</Button>
              )
            ) : null
          }
          content={
            <form autoComplete="off">
              {/* <Grid item md={3} sm={6} xs={12}> */}
              {/* <TextField
                      id='typeName'
                      select
                      label={<Translate i18nKey='typeName' />}
                      // value={this.state.typeName||''}
                      // onChange={this.handleChange('typeName')}
                        value={this.props.form?.attributes?.typeName || ''}
                        onChange={e =>
                        this.props.handleChangeForAttributesValues(
                          'typeName',
                          e
                        )}
                      margin='dense'
                      fullWidth
                    >
                      <MenuItem value=''>
                        <em>{<Translate i18nKey='none'/>}</em>
                      </MenuItem>
                      {allTypes.map(option => ( <MenuItem key={option} value={option}>{option}  </MenuItem>))}
                    </TextField>
                  </Grid> */}
              {/* multiple select hidden */}
              {/* <Grid item md={3} sm={6} xs={12}>
                <InputLabel htmlFor="name-multiple" style={{color:"#ffffff",fontSize:"11px"}}><Translate i18nKey='sharedType' /></InputLabel>
                    <Select
                      id='label'
                      label={<Translate i18nKey='label' />}
                      multiple
                      value={this.state?.typeName || ''}
                      onChange={this.handleChange}
                      // input={<Input />}
                      // MenuProps={MenuProps}
                      variant='outlined'
                      margin='dense'
                      fullWidth
                      classes={{
                        root: classes.whiteColor,
                        icon: classes.whiteColor
                      }}
                    >
                    {allTypes.map(option => (<MenuItem key={option} value={option}>{(option)} </MenuItem>))}
                    </Select>
                </Grid> */}
              {/* Row 1: VIN | City | Plate */}
              <Grid
                container
                spacing={2}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: 8,
                  }}
                >
                  {(() => {
                    const selectedCity = this.props.form?.cityId || {};
                    const plateValue =
                      this.props.form?.vehicleLicensePlate || "";
                    const { plateLetters, plateNumbers, valid } =
                      parseUaePlateParts(plateValue, selectedCity);
                    const style = resolveEmiratePlateStyle(selectedCity);
                    const hasCity = Boolean(
                      selectedCity?.id ||
                        selectedCity?.cityEn ||
                        selectedCity?.cityAr ||
                        selectedCity?.label,
                    );
                    const hasInput = Boolean(String(plateValue).trim());
                    // Regex-based preview: valid = solid; typing invalid = red border; empty = example
                    const borderColor = !hasCity
                      ? "#111"
                      : hasInput && selectedCity.regex
                        ? valid
                          ? "#111"
                          : "#e33c30"
                        : "#111";
                    const isPlaceholder = !hasInput && Boolean(selectedCity.msg);

                    return (
                      <div
                        style={{
                          minWidth: 260,
                          maxWidth: 340,
                          height: 64,
                          border: `2.5px solid ${borderColor}`,
                          borderRadius: 6,
                          background: "#fff",
                          display: "flex",
                          alignItems: "stretch",
                          overflow: "hidden",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
                          opacity: hasCity ? 1 : 0.55,
                        }}
                        title={
                          selectedCity.msg ||
                          selectedCity.regex ||
                          style.cityEn
                        }
                      >
                        {/* Category / code — from city regex match */}
                        <div
                          style={{
                            flex: "0 0 26%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: style.categoryBg,
                            color: style.categoryColor,
                            fontSize: 26,
                            fontWeight: 800,
                            letterSpacing: 1,
                            padding: "0 8px",
                            fontFamily:
                              "Arial Black, Arial, Helvetica, sans-serif",
                            opacity: isPlaceholder ? 0.45 : 1,
                          }}
                        >
                          {plateLetters || "—"}
                        </div>
                        {/* Emirate Arabic name */}
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderLeft: `2px solid ${borderColor}`,
                            borderRight: `2px solid ${borderColor}`,
                            padding: "0 10px",
                            background: "#fff",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 20,
                              fontWeight: 700,
                              color: "#111",
                              lineHeight: 1,
                              direction: "rtl",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {style.cityAr}
                          </span>
                        </div>
                        {/* Serial digits — from city regex match */}
                        <div
                          style={{
                            flex: "0 0 34%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#fff",
                            color: "#111",
                            fontSize: 26,
                            fontWeight: 800,
                            letterSpacing: 2,
                            padding: "0 8px",
                            fontFamily:
                              "Arial Black, Arial, Helvetica, sans-serif",
                            fontVariantNumeric: "tabular-nums",
                            opacity: isPlaceholder ? 0.45 : 1,
                          }}
                        >
                          {plateNumbers || "000"}
                        </div>
                      </div>
                    );
                  })()}
                </div>
              </Grid>
              <Grid container spacing={2}>
                {![1, 2, 3].includes(userType) && (
                  <Grid
                    item
                    md={3}
                    sm={6}
                    xs={12}
                    style={{ postion: "relative", zIndex: 16 }}
                  >
                    <SingleSelect
                      array={updatedUsers || []}
                      // async
                      isClearable
                      id="parentId"
                      selectName="parentId"
                      label={
                        <>
                          <Translate i18nKey="selectChildUsers" />
                          {[4, 5, 6].includes(userType) && <span> *</span>}
                        </>
                      }
                      // defaultOptions={this.props?.selectedMakeTypes || []}
                      value={
                        this.props.form &&
                        this.props.form.parentId &&
                        this.props.form.parentId.id
                          ? {
                              id: this.props.form.parentId.id,
                              value: this.props.form.parentId.id,
                              label:
                                this.props.form.parentId.label ||
                                this.props.form.parentId.name,
                            }
                          : ""
                      }
                      // index={index}
                      handleChange={this.props.handleChange}
                      canRemove={true}
                      canAssign={true}
                    />
                  </Grid>
                )}
                <Grid item md={3} sm={6} xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 8,
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ position: "relative" }}>
                        <TextField
                          id="vin"
                          label={<Translate i18nKey="vin *" />}
                          placeholder=""
                          value={this.props.form?.vin || ""}
                          onChange={(e) => this.props.handleChange("vin", e)}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          error={!this.props.isVin}
                          inputProps={{
                            maxLength: 17,
                          }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: 10,
                            top: "50%",
                            transform: "translateY(-20%)",
                            fontSize: 12,
                            color:
                              (this.props.form?.vin || "").length === 17
                                ? "#28A745"
                                : "#888",
                            pointerEvents: "none",
                          }}
                        >
                          {(this.props.form?.vin || "").length}/17
                        </span>
                      </div>
                      <FormHelperText
                        style={{
                          fontWeight: "bold",
                          color: !this.props.isVin ? "red" : "inherit",
                          fontSize: "12px",
                        }}
                        error={!this.props.isVin ? true : false}
                      >
                        {this.props.translate(
                          `VIN must be exactly 17 characters long and contain only alphanumeric characters.`,
                        )}
                      </FormHelperText>
                    </div>
                    <Button
                      onClick={() =>
                        this.props.getVehicleData && this.props.getVehicleData()
                      }
                      disabled={!this.props.isVin}
                      style={{ marginTop: 8, whiteSpace: "nowrap" }}
                    >
                      {this.props.translate("fetchData")}
                    </Button>
                  </div>
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ postion: "relative", zIndex: 14 }}
                >
                  <SingleSelect
                    array={cities || []}
                    isClearable
                    id="cityId"
                    selectName="cityId"
                    label={<Translate i18nKey="city" />}
                    value={
                      this.props.form &&
                      this.props.form.cityId &&
                      this.props.form.cityId.id
                        ? {
                            id: this.props.form.cityId.id,
                            value: this.props.form.cityId.label,
                            label: this.props.form.cityId.label,
                          }
                        : ""
                    }
                    handleChange={this.props.handleChangeForAttributesValues}
                    canRemove={true}
                    canAssign={true}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: "96%" }}>
                      <TextField
                        error={
                          this.props.vehicleLicensePlateError ? true : false
                        }
                        id="vehicleLicensePlate"
                        label={this.props.translate("plate#")}
                        required
                        placeholder=""
                        value={this.props.form.vehicleLicensePlate || ""}
                        onChange={(e) =>
                          this.props.handleChange("vehicleLicensePlate", e)
                        }
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        disabled={
                          this.props.editOption || !this.props.form?.cityId?.id
                        }
                      />
                    </div>
                    <HtmlTooltip
                      title={
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            width: "200px",
                            padding: "5px 0px",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {this.props.form?.cityId?.msg || ""}
                        </span>
                      }
                      style={{ color: "green" }}
                    >
                      <InfoIcon
                        fontSize="large"
                        style={{
                          fontSize: 24,
                          color: "#1E72B8",
                          marginLeft: "5px",
                        }}
                      />
                    </HtmlTooltip>
                  </div>
                  <FormHelperText
                    style={{
                      fontWeight: "bold",
                      color: "red",
                      fontSize: "12px",
                    }}
                    error={this.props.vehicleLicensePlateError ? true : false}
                  >
                    {this.props.form?.cityId?.msg || ""}
                  </FormHelperText>
                </Grid>
                {/* Row 2: Vehicle Type | Label */}

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="label"
                    label={<Translate i18nKey="label" />}
                    required
                    placeholder=""
                    value={this.props.form?.label || ""}
                    onChange={(e) => this.props.handleChange("label", e)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextField
                    id="category"
                    select
                    label={<Translate i18nKey="vehicleCategory" />}
                    value={this.props.form.category || ""}
                    onChange={(e) => this.props.handleChange("category", e)}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="dense"
                    fullWidth
                    required
                  >
                    <MenuItem value={0}>
                      <em>{<Translate i18nKey="none" />}</em>
                    </MenuItem>
                    {this.props?.categoriesList?.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ postion: "relative", zIndex: 4 }}
                >
                  <SingleSelect
                    array={this.props?.allMakes || []}
                    isClearable
                    isSearchable
                    isLoading={this.props.makesLoading}
                    filterOption={() => true}
                    id="make"
                    selectName="make"
                    label={<Translate i18nKey="make" />}
                    value={
                      this.props.form && this.props.form.make
                        ? {
                            id:
                              this.props.form.make.key ||
                              this.props.form.make.id,
                            value: this.props.form.make.label,
                            label: this.props.form.make.label,
                          }
                        : ""
                    }
                    handleChange={this.props.handleChangeForAttributesValues}
                    onInputChange={this.props.onMakeInputChange}
                    onMenuScrollToBottom={this.props.loadMoreMakes}
                    canRemove={true}
                    canAssign={true}
                    // menuPlacement="auto"
                    // menuPortalTarget=s{document.body}
                    // styles={{
                    //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    // }}
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ postion: "relative", zIndex: 12 }}
                >
                  <SingleSelect
                    array={this.props?.selectedMakeTypes || []}
                    isClearable
                    id="modelId"
                    selectName="modelId"
                    label={<Translate i18nKey="model" />}
                    value={
                      this.props.form &&
                      this.props.form.modelId &&
                      this.props.form.modelId.id
                        ? {
                            id: this.props.form.modelId.id,
                            value: this.props.form.modelId.label,
                            label: this.props.form.modelId.label,
                          }
                        : ""
                    }
                    handleChange={this.props.handleChangeForAttributesValues}
                    canRemove={true}
                    canAssign={true}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="year"
                    type="number"
                    label={<Translate i18nKey="year" />}
                    placeholder=""
                    value={this.props.form?.attributes?.year || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "year",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={this.props.yearError}
                  />
                  <FormHelperText
                    style={{
                      color: this.props.yearError ? "red" : "inherit",
                      fontSize: "12px",
                    }} // Changed fontWeight and color
                    error={this.props.yearError ? true : false}
                  >
                    {this.props.translate(`makeYearCurrentYear`)}
                  </FormHelperText>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="variant"
                    label={<Translate i18nKey="engineVariant" />}
                    placeholder=""
                    value={this.props.form?.attributes?.variant || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("variant", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ position: "relative" }}
                >
                  {/* <TextField
                    id="fuel_type"
                    label={<Translate i18nKey="fuel_type" />}
                    placeholder=""
                    value={this.props.form?.attributes?.fuel_type || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "fuel_type",
                        e
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  /> */}
                  <label
                    style={{
                      fontSize: "0.75em",
                      lineHeight: "1",
                      position: "absolute",
                      zIndex: "1",
                      background: "#fff",
                      padding: "0 5px",
                      left: "14px",
                    }}
                  >
                    {this.props.translate("fuel_type*")}
                  </label>
                  <SingleSelect
                    array={this.props.fuel_typeList || []}
                    // async
                    isClearable
                    id="fuel_type"
                    selectName="fuel_type"
                    // label={<Translate i18nKey="fuel_type" />}
                    value={
                      this.props.form &&
                      this.props.form.attributes &&
                      this.props.form.attributes.fuel_type
                        ? {
                            id: this.props.form.attributes.fuel_type,
                            label: this.props.form.attributes.fuel_type,
                            value: this.props.form.attributes.fuel_type,
                          }
                        : ""
                    }
                    onChange={this.props.handleChange}
                    handleChange={this.props.handleChange}
                    canRemove={true}
                    translate={this.props.translate}
                    canAssign={true}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="color"
                    label={<Translate i18nKey="attributeColor" />}
                    placeholder=""
                    value={this.props.form?.attributes?.color || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "color",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format="DD/MM/YYYY"
                    error={
                      this.props.form.expirationTime &&
                      this.props.form.expirationTime < moment().startOf("day")
                    }
                    helperText={
                      this.props.form.expirationTime &&
                      this.props.form.expirationTime <
                        moment().startOf("day") ? (
                        <Translate i18nKey="licenseExpired" />
                      ) : (
                        ""
                      )
                    }
                    margin="dense"
                    label={<Translate i18nKey="V/LExpirationTime" />}
                    variant="outlined"
                    fullWidth
                    minDate={new Date()}
                    value={
                      this.props.form.expirationTime
                        ? `${this.props.form.expirationTime}`
                        : null
                    }
                    onChange={this.props.handleChangeLicenseExpDate(
                      "expirationTime",
                    )}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format="DD/MM/YYYY"
                    error={
                      this.props.form.insuranceTime &&
                      this.props.form.insuranceTime < moment().startOf("day")
                    }
                    helperText={
                      this.props.form.insuranceTime &&
                      this.props.form.insuranceTime <
                        moment().startOf("day") ? (
                        <Translate i18nKey="insuranceExpirationTime" />
                      ) : (
                        ""
                      )
                    }
                    margin="dense"
                    label={<Translate i18nKey="insuranceExpirationTime" />}
                    variant="outlined"
                    fullWidth
                    minDate={new Date()}
                    value={
                      this.props.form.insuranceTime
                        ? `${this.props.form.insuranceTime}`
                        : null
                    }
                    onChange={this.props.handleChangeLicenseExpDate(
                      "insuranceTime",
                    )}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <CustomDatePicker
                    format="DD/MM/YYYY"
                    error={
                      this.props.form.complianceTime &&
                      this.props.form.complianceTime < moment().startOf("day")
                    }
                    helperText={
                      this.props.form.complianceTime &&
                      this.props.form.complianceTime <
                        moment().startOf("day") ? (
                        <Translate i18nKey="complianceExpirationTime" />
                      ) : (
                        ""
                      )
                    }
                    margin="dense"
                    label={<Translate i18nKey="complianceExpirationTime" />}
                    variant="outlined"
                    fullWidth
                    minDate={new Date()}
                    value={
                      this.props.form.complianceTime
                        ? `${this.props.form.complianceTime}`
                        : null
                    }
                    onChange={this.props.handleChangeLicenseExpDate(
                      "complianceTime",
                    )}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    type="number"
                    id="fuelEfficiency"
                    label={<Translate i18nKey="fuelEfficiency" />}
                    // required
                    placeholder=""
                    value={this.props.form?.fuelEfficiency || ""}
                    onChange={(e) =>
                      this.props.handleChange("fuelEfficiency", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="totalAvailablekm"
                    label={this.props.translate("Standard Daily Mileage (km)")}
                    placeholder=""
                    value={this.props.form?.totalAvailablekm || ""}
                    onChange={(e) =>
                      this.props.handleChange("totalAvailablekm", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={this.props.form?.totalAvailablekm < 1 ? true : false}
                  />
                  <FormHelperText
                    error={this.props.form?.totalAvailablekm < 1 ? true : false}
                  >
                    {this.props.translate("mustBeGreaterthan0")}
                  </FormHelperText>
                </Grid>

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="wheels"
                    label={<Translate i18nKey="wheelsNumber" />}
                    placeholder=""
                    value={this.props.form?.attributes?.wheels || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("wheels", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="country"
                    label={<Translate i18nKey="country" />}
                    placeholder=""
                    value={this.props.form?.attributes?.country || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("country", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ postion: "relative", zIndex: 12 }}
                >
                  <SingleSelect
                    array={cities || []}
                    isClearable
                    id="cityIdBranch"
                    selectName="cityId"
                    label={<Translate i18nKey="city" />}
                    value={
                      this.props.form &&
                      this.props.form.cityId &&
                      this.props.form.cityId.id
                        ? {
                            id: this.props.form.cityId.id,
                            value: this.props.form.cityId.label,
                            label: this.props.form.cityId.label,
                          }
                        : ""
                    }
                    handleChange={this.props.handleChangeForAttributesValues}
                    canRemove={true}
                    canAssign={true}
                    menuPlacement="auto"
                    // menuPortalTarget=s{document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Grid>
                {/* <Grid item md={3} sm={6} xs={12} /> Row 3: Arabic Plate | Entitlement | Country */}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="vehicleLisencePlateArabic"
                    label={<Translate i18nKey="arabicPlate#" />}
                    placeholder=""
                    value={this.props.form?.vehicleLisencePlateArabic || ""}
                    onChange={(e) =>
                      this.props.handleChange("vehicleLisencePlateArabic", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    disabled={this.props.editOption}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="entitlement"
                    select
                    label={this.props.translate("vehicleEntitlement")}
                    value={this.props.form?.entitlement || ""}
                    onChange={(e) => this.props.handleChange("entitlement", e)}
                    margin="dense"
                    fullWidth
                  >
                    {vehicleEntitlementList?.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {this.props.translate(option.name)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Row 4: Registration Number | Variant | Wheels */}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="registrationNumber"
                    label={<Translate i18nKey="registrationNumber" />}
                    placeholder=""
                    value={
                      this.props.form?.attributes?.registrationNumber || ""
                    }
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "registrationNumber",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                {/* Row 5: Make | Model | Transmission */}

                <Grid item md={3} sm={6} xs={12}>
                  <SingleSelect
                    array={this.props?.trasmissionList || []}
                    selectName="trasmissionType"
                    label={<Translate i18nKey="trasmissionType" />}
                    value={
                      this.props.form &&
                      this.props.form.attributes &&
                      this.props.form.attributes.trasmissionType
                        ? {
                            id: this.props.form.attributes.trasmissionType,
                            label: this.props.form.attributes.trasmissionType,
                            value: this.props.form.attributes.trasmissionType,
                          }
                        : ""
                    }
                    handleChange={this.props.handleChangeForAttributesValues}
                    canRemove={true}
                    canAssign={true}
                    translate={this.props.translate}
                  />
                </Grid>
                {/* Row 6: Year | Color | Fuel Type */}

                {/* Row 7: Fuel Efficiency | Standard Daily Mileage | Odometer */}

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    type="number"
                    id="odometer"
                    label={<Translate i18nKey="odometer" />}
                    // required
                    placeholder=""
                    value={this.props.form?.odometer || ""}
                    onChange={(e) => this.props.handleChange("odometer", e)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                {/* Row 8: Capacity | Garage | Fleet */}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="capacity"
                    label={<Translate i18nKey="fuelTankCapacity" />}
                    placeholder=""
                    value={this.props.form?.attributes?.capacity || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "capacity",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="garage"
                    label={<Translate i18nKey="workshop" />}
                    placeholder=""
                    value={this.props?.form?.garage || ""}
                    onChange={(e) => this.props.handleChange("garage", e)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="fleetReferenceNumber"
                    label={<Translate i18nKey="fleetNumber" />}
                    placeholder=""
                    value={
                      this.props.form?.attributes?.registrationNumber || ""
                    }
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "registrationNumber",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                {/* Row 9: Chassis | Registration Expiry | Driver Cost */}
                <Grid item xs={12}>
                  <h3 style={{ margin: 0 }} className="with-border page-title">
                    {<Translate i18nKey="unit" />}
                  </h3>
                </Grid>
                <Grid
                  item
                  md={3}
                  sm={6}
                  xs={12}
                  style={{ postion: "relative", zIndex: 11 }}
                >
                  <SearchDevices
                    isMulti={false}
                    api="devices"
                    isClearable
                    onChange={this.props.onChangedDevice}
                    value={
                      this.props?.vehicleTracker
                        ? {
                            id: this.props?.vehicleTracker?.value || "",
                            value: this.props?.vehicleTracker?.value || "",
                            label: this.props?.vehicleTracker?.label || "",
                          }
                        : null
                    }
                    placeholder={<Translate i18nKey="gpsUnit" />}
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="imei"
                    label={<Translate i18nKey="imei" />}
                    placeholder=""
                    value={this.props.form.imei || ""}
                    onChange={(e) => this.props.handleChange("imei", e)}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <TextField
                    id="unitIcon"
                    select
                    label={<Translate i18nKey="unitIcon" />}
                    value={this.props.form.unitIcon || ""}
                    onChange={(e) => this.props.handleChange("unitIcon", e)}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value="">
                      <em>{<Translate i18nKey="none" />}</em>
                    </MenuItem>
                    {(this.props?.unitIconList || []).map((option) => (
                      <MenuItem key={option} value={option}>
                        {this.props.translate
                          ? this.props.translate(option)
                          : option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <h3 style={{ margin: 0 }} className="with-border page-title">
                    {<Translate i18nKey="costing" />}
                  </h3>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="chassisNumber"
                    label={<Translate i18nKey="vehicleSerialNumber" />}
                    placeholder=""
                    value={this.props.form?.attributes?.chassisNumber || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "chassisNumber",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="driverCost"
                    label={<Translate i18nKey="driverCost" />}
                    placeholder=""
                    value={this.props.form?.attributes?.driverCost || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "driverCost",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                {/* Row 10: Fines | Branding | Telematics */}
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="fines"
                    label={<Translate i18nKey="fines" />}
                    placeholder=""
                    value={this.props.form?.attributes?.fines || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("fines", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="brandingCost"
                    label={<Translate i18nKey="brandingCost" />}
                    placeholder=""
                    value={this.props.form?.attributes?.brandingCost || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "brandingCost",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    type="number"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="telematicsCost"
                    label={<Translate i18nKey="telematicsCost" />}
                    placeholder=""
                    value={this.props.form?.attributes?.telematicsCost || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues(
                        "telematicsCost",
                        e,
                      )
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    type="number"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="otherCost"
                    label={<Translate i18nKey="otherCost" />}
                    placeholder=""
                    value={this.props.form?.attributes?.otherCost || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("otherCost", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    type="number"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="SIMNumber"
                    label={<Translate i18nKey="SIMNumber" />}
                    placeholder=""
                    value={this.props.form?.attributes?.SIMNumber || ""}
                    onChange={(e) =>
                      this.props.handleChangeForAttributesValues("SIMNumber", e)
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                {checkPrivileges("area") ? (
                  <Grid
                    item
                    md={3}
                    sm={6}
                    xs={12}
                    style={{ postion: "relative", zIndex: 1 }}
                  >
                    <SingleSelect
                      array={this.props?.areaList || []}
                      selectName="areaId"
                      label={<Translate i18nKey="vehicleArea" />}
                      value={
                        this.props.form &&
                        this.props.form.areaId &&
                        this.props.form.areaId.key
                          ? {
                              id: this.props.form.areaId.key,
                              value: this.props.form.areaId.key,
                              label: this.props.form.areaId.name,
                              uniqueId: this.props.form.areaId.uniqueId,
                            }
                          : ""
                      }
                      // value={this.props.form.vehicleType || ''}
                      // onChange={e => this.props.handleChange('vehicleType', e)}
                      handleChange={this.props.handleChange}
                      canRemove={true}
                      canAssign={true}
                    />
                  </Grid>
                ) : null}

                {/* Row 12: Branch | Insurance Expiry | Compliance Expiry */}

                {this.props?.serversettings?.contractType !== 1 ? (
                  <>
                    <Grid
                      item
                      md={3}
                      sm={6}
                      xs={12}
                      style={{ display: "flex", marginTop: 10 }}
                    >
                      <Checkbox
                        checked={this.props.form?.onLease || ""}
                        onChange={(e) => this.props.handleChange("onLease", e)}
                        value="type"
                        canAssign
                        canRemove
                        label={<Translate i18nKey="leasing" />}
                      />
                    </Grid>

                    {/*---end--- */}

                    {/* ------state-------------upload pdf file-----pending task from backEnd
                <Grid item md={3} sm={6} xs={12}>
                  <Tooltip title='Upload pdf'>
                    <Button
                      style={{ float: 'right', maxWidth: '40px',minWidth: '40px' }}
                      variant='contained'
                      margin='dense'
                      component="label"
                      onChange={e => this.uploadFile(e)}
                    >
                      <PublishIcon  style={{ color: '#fff'}}/>
                      <input
                        type="file"
                        hidden
                      />
                    </Button>
                  </Tooltip>
                </Grid>
                ----end---- */}
                    {/* <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='permittedSpeed'
                    type='number'
                    label={<Translate i18nKey='permittedSpeed' />}
                    placeholder=''
                    value={this.props.form.attributes.permittedSpeed || ''}
                    onChange={e =>
                      this.props.handleChangeForAttributesValues(
                        'permittedSpeed',
                        e
                      )
                    }
                    variant='outlined'
                    margin='dense'
                    fullWidth
                  />
                </Grid> */}

                    {this.props.form && this.props.form.onLease ? (
                      <>
                        <Grid item xs={12}>
                          <h3
                            style={{ margin: 0 }}
                            className="with-border page-title"
                          >
                            {<Translate i18nKey="leasing" />}
                          </h3>
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="purchasePrice"
                            label={<Translate i18nKey="purchasePrice" />}
                            placeholder=""
                            value={this.props.form?.purchasePrice || ""}
                            onChange={(e) =>
                              this.props.handleChange("purchasePrice", e)
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="monthlyRate"
                            label={<Translate i18nKey="monthlyRate" />}
                            placeholder=""
                            value={this.props.form?.monthlyRate || ""}
                            onChange={(e) =>
                              this.props.handleChange("monthlyRate", e)
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="poolType"
                            select
                            label={<Translate i18nKey="poolType" />}
                            value={this.props.form?.attributes?.poolType || ""}
                            // onChange={this.handleChange('typeName')}
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "poolType",
                                e,
                              )
                            }
                            margin="dense"
                            fullWidth
                          >
                            <MenuItem value="">
                              <em>{<Translate i18nKey="none" />}</em>
                            </MenuItem>
                            {poolTypes?.map((option) => (
                              <MenuItem key={option.key} value={option.key}>
                                {option.name}{" "}
                              </MenuItem>
                            ))}
                          </TextField>
                          {/* <TextField
                        id='poolType'
                        label={<Translate i18nKey='poolType' />}
                        placeholder=''
                        value={this.props.form?.attributes?.poolType || ''}
                        onChange={e =>
                          this.props.handleChangeForAttributesValues(
                            'poolType',
                            e
                          )
                        }
                        variant='outlined'
                        margin='dense'
                        fullWidth
                      /> */}
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="insurancePercentage"
                            label={<Translate i18nKey="insurancePercentage" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes
                                ?.insurancePercentage || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "insurancePercentage",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="bankPercentage"
                            label={<Translate i18nKey="bankPercentage" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes?.bankPercentage || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "bankPercentage",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="Maintenance"
                            label={<Translate i18nKey="maintenanceCost" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes?.Maintenance || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "Maintenance",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="zakatPercentage"
                            label={<Translate i18nKey="zakatPercentage" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes?.zakatPercentage || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "zakatPercentage",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="resalePercentage"
                            label={<Translate i18nKey="resalePercentage" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes?.resalePercentage ||
                              ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "resalePercentage",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="replacement"
                            label={
                              <Translate i18nKey="replacementPercentage" />
                            }
                            placeholder=""
                            value={
                              this.props.form?.attributes?.replacement || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "replacement",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="standByVehicle"
                            label={<Translate i18nKey="standByVehicle" />}
                            placeholder=""
                            value={
                              this.props.form?.attributes?.standByVehicle || ""
                            }
                            onChange={(e) =>
                              this.props.handleChangeForAttributesValues(
                                "standByVehicle",
                                e,
                              )
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          helperText={
                            this.props.form &&
                            this.props.form.attributes &&
                            this.props.form.attributes.purchaseDate <
                              moment().startOf("day").toISOString() ? (
                              <Translate i18nKey="purchaseDate" />
                            ) : (
                              ""
                            )
                          }
                          margin="dense"
                          label={<Translate i18nKey="purchaseDate" />}
                          variant="outlined"
                          fullWidth
                          // minDate={new Date()}
                          value={
                            this.props.form && this.props.form.purchaseDate
                              ? new Date(
                                  `${this.props.form.purchaseDate}`
                                ).toString()
                              : null
                          }
                          onChange={this.props.handleChangeLicenseExpDate(
                            "purchaseDate"
                          )}
                          InputProps={{
                            classes: {
                              root: "theme-cssOutlinedInput",
                              input: "theme-input",
                              focused: "theme-cssFocused",
                              notchedOutline: "theme-notchedOutline",
                            },
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "theme-label",
                              focused: "theme-label-focused",
                              shrink: "theme-label-shrink",
                            },
                          }}
                        />
                      </LocalizationProvider> */}

                          <CustomDatePicker
                            format="DD/MM/YYYY"
                            margin="dense"
                            label={this.props.translate("purchaseDate")}
                            variant="outlined"
                            fullWidth
                            required
                            // minDate={new Date()}
                            value={
                              this.props.form.purchaseDate
                                ? `${this.props.form.purchaseDate}`
                                : null
                            }
                            onChange={this.props.handleChangeLicenseExpDate(
                              "purchaseDate",
                            )}
                          />
                        </Grid>

                        <Grid item md={3} sm={6} xs={12}>
                          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          required
                          margin="dense"
                          label={<Translate i18nKey="deliveryDate" />}
                          variant="outlined"
                          fullWidth
                          // minDate={new Date()}
                          value={
                            this.props.form && this.props.form.deliveryDate
                              ? new Date(
                                  `${this.props.form.deliveryDate}`
                                ).toString()
                              : null
                          }
                          onChange={this.props.handleChangeLicenseExpDate(
                            "deliveryDate"
                          )}
                          InputProps={{
                            classes: {
                              root: "theme-cssOutlinedInput",
                              input: "theme-input",
                              focused: "theme-cssFocused",
                              notchedOutline: "theme-notchedOutline",
                            },
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "theme-label",
                              focused: "theme-label-focused",
                              shrink: "theme-label-shrink",
                            },
                          }}
                        />
                      </LocalizationProvider> */}

                          <CustomDatePicker
                            format="DD/MM/YYYY"
                            margin="dense"
                            label={this.props.translate("deliveryDate")}
                            variant="outlined"
                            fullWidth
                            required
                            // minDate={new Date()}
                            value={
                              this.props.form.deliveryDate
                                ? `${this.props.form.deliveryDate}`
                                : null
                            }
                            onChange={this.props.handleChangeLicenseExpDate(
                              "deliveryDate",
                            )}
                          />
                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                        required
                          format="DD/MM/YYYY"
                          margin="dense"
                          label={<Translate i18nKey="leaseStartDate" />}
                          variant="outlined"
                          fullWidth
                          // minDate={new Date()}
                          value={
                            this.props.form && this.props.form.leaseStartDate
                              ? new Date(
                                  `${this.props.form.leaseStartDate}`
                                ).toString()
                              : null
                          }
                          onChange={this.props.handleChangeLicenseExpDate(
                            "leaseStartDate"
                          )}
                          InputProps={{
                            classes: {
                              root: "theme-cssOutlinedInput",
                              input: "theme-input",
                              focused: "theme-cssFocused",
                              notchedOutline: "theme-notchedOutline",
                            },
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "theme-label",
                              focused: "theme-label-focused",
                              shrink: "theme-label-shrink",
                            },
                          }}
                        />
                      </LocalizationProvider> */}

                          <CustomDatePicker
                            format="DD/MM/YYYY"
                            margin="dense"
                            label={this.props.translate("leaseStartDate")}
                            variant="outlined"
                            fullWidth
                            required
                            // minDate={new Date()}
                            value={
                              this.props.form.leaseStartDate
                                ? `${this.props.form.leaseStartDate}`
                                : null
                            }
                            onChange={this.props.handleChangeLicenseExpDate(
                              "leaseStartDate",
                            )}
                          />
                        </Grid>

                        <Grid item md={3} sm={6} xs={12}>
                          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          error={
                            this.props.form &&
                            this.props.form.leaseEndDate &&
                            this.props.form.leaseEndDate <
                              moment().startOf("day").toISOString()
                          }
                          required
                          margin="dense"
                          label={<Translate i18nKey="leaseEndDate" />}
                          variant="outlined"
                          fullWidth
                          // minDate={new Date()}
                          value={
                            this.props.form && this.props.form.leaseEndDate
                              ? new Date(
                                  `${this.props.form.leaseEndDate}`
                                ).toString()
                              : null
                          }
                          onChange={this.props.handleChangeLicenseExpDate(
                            "leaseEndDate"
                          )}
                          InputProps={{
                            classes: {
                              root: "theme-cssOutlinedInput",
                              input: "theme-input",
                              focused: "theme-cssFocused",
                              notchedOutline: "theme-notchedOutline",
                            },
                          }}
                          InputLabelProps={{
                            classes: {
                              root: "theme-label",
                              focused: "theme-label-focused",
                              shrink: "theme-label-shrink",
                            },
                          }}
                        />
                      </LocalizationProvider> */}

                          <CustomDatePicker
                            format="DD/MM/YYYY"
                            margin="dense"
                            label={this.props.translate("leaseEndDate")}
                            variant="outlined"
                            fullWidth
                            required
                            // minDate={new Date()}
                            value={
                              this.props.form.leaseEndDate
                                ? `${this.props.form.leaseEndDate}`
                                : null
                            }
                            onChange={this.props.handleChangeLicenseExpDate(
                              "leaseEndDate",
                            )}
                          />
                        </Grid>

                        <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="leasePeriod"
                            label={<Translate i18nKey="leasePeriod" />}
                            placeholder=""
                            value={this.props.form?.leasePeriod || ""}
                            onChange={(e) =>
                              this.props.handleChange("leasePeriod", e)
                            }
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                      </>
                    ) : null}
                  </>
                ) : (
                  ""
                )}

                <Grid item xs={12}>
                  <h3 style={{ margin: 0 }} className="with-border page-title">
                    {<Translate i18nKey="tags" />}
                  </h3>
                </Grid>

                <Grid item md={3} sm={6} xs={12}>
                  {this.props.form?.attributes?.tags || ""}
                  <TextField
                    id="tag_1"
                    label={
                      this.props.logInUsers.attributes &&
                      this.props.logInUsers.attributes.vt1 ? (
                        this.props.logInUsers.attributes.vt1
                      ) : (
                        <Translate i18nKey="tag_1" />
                      )
                    }
                    placeholder=""
                    value={this.props.form?.attributes?.tag_1 || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "tag_1",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="tag_2"
                    label={
                      this.props.logInUsers.attributes &&
                      this.props.logInUsers.attributes.vt2 ? (
                        this.props.logInUsers.attributes.vt2
                      ) : (
                        <Translate i18nKey="tag_2" />
                      )
                    }
                    placeholder=""
                    value={this.props.form?.attributes?.tag_2 || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "tag_2",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="tag_3"
                    label={
                      this.props.logInUsers.attributes &&
                      this.props.logInUsers.attributes.vt3 ? (
                        this.props.logInUsers.attributes.vt3
                      ) : (
                        <Translate i18nKey="tag_3" />
                      )
                    }
                    placeholder=""
                    value={this.props.form?.attributes?.tag_3 || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "tag_3",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="tag_4"
                    label={
                      this.props.logInUsers.attributes &&
                      this.props.logInUsers.attributes.vt4 ? (
                        this.props.logInUsers.attributes.vt4
                      ) : (
                        <Translate i18nKey="tag_4" />
                      )
                    }
                    placeholder=""
                    value={this.props.form?.attributes?.tag_4 || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "tag_4",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id="tag_5"
                    label={
                      this.props.logInUsers.attributes &&
                      this.props.logInUsers.attributes.vt5 ? (
                        this.props.logInUsers.attributes.vt5
                      ) : (
                        <Translate i18nKey="tag_5" />
                      )
                    }
                    placeholder=""
                    value={this.props.form?.attributes?.tag_5 || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "tag_5",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <h3 style={{ margin: 0 }} className="with-border page-title">
                    {<Translate i18nKey="integration" />}
                  </h3>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <label style={{ position: "static" }}>
                    {<Translate i18nKey="sequenceNumber" />}
                  </label>
                  <TextField
                    id="sequenceNumber"
                    label={<Translate i18nKey="sequenceNumber" />}
                    placeholder=""
                    value={this.props.form?.attributes?.sequenceNumber || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "sequenceNumber",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                  <small>
                    <em>{this.state.inquiryResponse}</em>
                  </small>
                </Grid>
                <Grid item md={8} sm={6} xs={12}>
                  <label
                    style={{
                      position: "static",
                      marginBottom: 8,
                      display: "block",
                    }}
                  >
                    &nbsp;
                  </label>
                  {waslEnabled && waslCompanyRefKey ? (
                    <Button onClick={this.verify}>
                      Check already registered
                    </Button>
                  ) : null}
                </Grid>
                <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                  <h4 style={{ marginBottom: 0 }}>
                    {<Translate i18nKey="vehicleLicensePlate" />}
                  </h4>
                </Grid>
                <Grid
                  item
                  style={{ position: "relative", zIndex: 8 }}
                  md={2}
                  sm={6}
                  xs={12}
                >
                  <label>{<Translate i18nKey="plateType" />}</label>
                  <Selector
                    key="plateType"
                    array={plateTypes}
                    multi={
                      this.props.form?.attributes?.plateType &&
                      plateTypes.filter(
                        (e) => this.props.form.attributes.plateType === e.id,
                      )
                    }
                    onChange={(e) => this.handleChange("plateType", e)}
                    canAssign={true}
                    canRemove={true}
                  />
                </Grid>
                <Grid
                  item
                  style={{ position: "relative", zIndex: 6 }}
                  md={2}
                  sm={6}
                  xs={12}
                >
                  <label>{<Translate i18nKey="leftLetter" />}</label>
                  <TextField
                    id="leftLetter"
                    label={null}
                    placeholder=""
                    value={this.props.form?.attributes?.leftLetter || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "leftLetter",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  style={{ position: "relative", zIndex: 4 }}
                  md={2}
                  sm={6}
                  xs={12}
                >
                  <label>{<Translate i18nKey="middleLetter" />}</label>
                  <TextField
                    id="middleLetter"
                    label={null}
                    placeholder=""
                    value={this.props.form?.attributes?.middleLetter || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "middleLetter",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  style={{ position: "relative", zIndex: 2 }}
                  md={2}
                  sm={6}
                  xs={12}
                >
                  <label>{<Translate i18nKey="rightLetter" />}</label>
                  <TextField
                    id="rightLetter"
                    label={null}
                    placeholder=""
                    value={this.props.form?.attributes?.rightLetter || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "rightLetter",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <label>{<Translate i18nKey="number" />}</label>
                  <TextField
                    id="number"
                    label={null}
                    placeholder=""
                    value={this.props.form?.attributes?.number || ""}
                    onChange={(e) => {
                      return this.props.handleChangeForAttributesValues(
                        "number",
                        e,
                      );
                    }}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
              </Grid>
              {this.state.errorResponse ? (
                <p>WASL ERROR: {this.state.errorResponse}</p>
              ) : null}
              {this.props.vehicleStatus ? (
                <ul className="process-list">
                  <li>Vehicle Status: {this.props?.vehicleStatus || ""}</li>
                </ul>
              ) : null}
            </form>
          }
        />
      </div>
    );
  }
}
// const AddVehicle = withStyles(styles)(withTranslationWrapper(addVehicle));

// export default AddVehicle;
const mapStateToProps = (state, ownProps) => {
  return {
    logInUsers: state.logInUsers,
    themecolors: state.themeColors,
  };
};
const AddVehicle = withStyles(styles);
export default AddVehicle(addVehicle);
